<script setup lang="ts">
import { useSelectSubstitutionReason } from '../../../model/additional-info/support/info-substitute-tutor/select-substitution-reason.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import SelectSubstitutionReason from './info-substitute-tutor/SelectSubstitutionReason.vue'

defineOptions({
  name: 'InfoSubstituteTutor',
})

const { isRequired } = useSelectSubstitutionReason()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Substitution reason"
      :required="isRequired"
    >
      <SelectSubstitutionReason />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
